import { render, staticRenderFns } from "./SalesDetailOrderProduct.vue?vue&type=template&id=dc1f7870&scoped=true&"
import script from "./SalesDetailOrderProduct.vue?vue&type=script&lang=js&"
export * from "./SalesDetailOrderProduct.vue?vue&type=script&lang=js&"
import style0 from "./SalesDetailOrderProduct.vue?vue&type=style&index=0&id=dc1f7870&lang=scss&scoped=true&"
import style1 from "./SalesDetailOrderProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1f7870",
  null
  
)

export default component.exports